/**
 * @flow
 */

import React from 'react';
import { useApolloClient } from '@apollo/client';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Dropdown } from 'semantic-ui-react';

import { logout } from '../../../actions/user';

const LogoutItem = () => {
    const client = useApolloClient();
    const dispatch = useDispatch();

    const onLogout = () => {
        dispatch(logout());
        // Reset the Apollo store after the logout action so the cleared
        // session is in place before cache reads re-run.
        setTimeout(() => {
            client.resetStore();
        }, 0);
    };

    return (
        <Dropdown.Item
            onClick={onLogout}
            icon="sign out"
            text={
                <FormattedMessage
                    id="navbar.menu.signOut"
                    defaultMessage="Sign Out"
                />
            }
        />
    );
};

export default LogoutItem;
